module.exports = __webpack_public_path__ + "static/media/classroom_view_create_section_video.6aa72d64.mov";